/** @jsx jsx */
import { jsx } from 'theme-ui'
import React from 'react'
import { Box } from '.'

export const Ellipsis: React.FC<{}> = (props) => (
  <Box
    sx={{
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    }}
    {...props}
  />
)
